module.exports = __webpack_public_path__ + "img/respaldo.f6de373c.png";